package entities

import kotlinx.serialization.Serializable

@Serializable
data class Category(
    val id: Int,
    val name: String,
    val parent_id: Int,
    val iscategory: Boolean,
    val isactive: Boolean
)